import { Observable } from "rxjs";
import { map } from "rxjs/operators";

export class PageAccessLogService {
  public static getPageAccessLog(page: string): Observable<boolean> {
    return window.axios
      .get<boolean>(`/pageaccesslog?page=${page}`)
      .pipe(map((response) => response.data));
  }

  public static updatePageAccessLog(page: string): Observable<any> {
    return window.axios
      .post<any>(`/pageaccesslog?page=${page}`)
      .pipe(map((response) => response.data));
  }
}
